import React from 'react'
import { useDispatch } from 'react-redux'

import { startInventoryBulkPricesSession } from '~/store/duck/bulkPrices'

import BulkPricingLink from '../bulk-prices/BulkPricingLink'

const InventoryBulkPricingLink = () => {
  const dispatch = useDispatch()

  const startNewSession = (force?: boolean) => {
    dispatch(
      startInventoryBulkPricesSession({
        force,
        navigateTo: '/admin/catalog/inventories/prices',
      }),
    )
  }
  return <BulkPricingLink startNewSession={startNewSession} />
}

export default InventoryBulkPricingLink
